// AI编辑器功能 Mixin
// 提供AI续写、纠错、翻译、画图、创作、改写、素材、工具等功能

// 导入AI组件
import Continue from '@/components/AI/continue.vue'
import Correction from '@/components/AI/correction.vue'
import Translation from '@/components/AI/translation.vue'
import Draw from '@/components/AI/draw.vue'
import Material from '@/components/AI/material.vue'
import Creation from '@/components/AI/creation.vue'
import Menutool from '@/components/AI/menutool.vue'
import Rewrite from '@/components/AI/rewrite.vue'

export default {
	components: {
		Continue,
		Correction,
		Translation,
		Draw,
		Material,
		Creation,
		Menutool,
		Rewrite
	},
	
	data() {
		return {
			// AI相关数据
			selContent: '',
			toolbarConfig: {
				aiContinue: {
					title: 'AI续写',
					icon: 'aiIcon ai-continue',
					action: (editor) => {
						this.onAiShow('continueRef');
					}
				},
				aiCreation: {
					title: 'AI创作',
					icon: 'aiIcon ai-creation',
					action: (editor) => {
						this.onAiShow('creationRef');
					}
				},
				aiCorrection: {
					title: 'AI纠错',
					icon: 'aiIcon ai-correction',
					action: (editor) => {
						this.onAiShow('correctionRef');
					}
				},
				aiTranslation: {
					title: 'AI翻译',
					icon: 'aiIcon ai-translation',
					action: (editor) => {
						this.onAiShow('translationRef');
					}
				},
				aiDraw: {
					title: 'AI绘画',
					icon: 'aiIcon ai-draw',
					action: (editor) => {
						this.onAiShow('drawRef');
					}
				},
				customimage: {
					title: '上传图片',
					icon: 'v-md-icon-img v-md-editor__toolbar-item-image',
					action: (editor) => {
						this.onPluginClick({ type: 'customimage' });
					}
				}
			}
		}
	},
	
	methods: {
		/**
		 * 获取当前内容 - 需要在使用的组件中实现
		 * @returns {string} 当前编辑器内容
		 */
		getCurrentContent() {
			throw new Error('getCurrentContent method must be implemented in the component')
		},
		
		/**
		 * 设置当前内容 - 需要在使用的组件中实现
		 * @param {string} content 要设置的内容
		 */
		setCurrentContent(content) {
			throw new Error('setCurrentContent method must be implemented in the component')
		},
		
		/**
		 * 获取当前编辑器 - 需要在使用的组件中实现
		 * @returns {Object} 当前编辑器实例
		 */
		getCurrentEditor() {
			throw new Error('getCurrentEditor method must be implemented in the component')
		},
		
		// 替换选中的内容
		replaceSelectedContent(newContent) {
			console.log('替换选中内容:', newContent, 'selContent:', this.selContent)
			if (this.selContent) {
				const currentContent = this.getCurrentContent()
				const replacedContent = currentContent.replace(this.selContent, newContent)
				this.setCurrentContent(replacedContent)
			} else {
				// 如果没有选中内容，则替换全部内容
				this.setCurrentContent(newContent)
			}
		},
		
		// 在选中内容后添加新内容
		insertAfterSelectedContent(newContent) {
			console.log('在选中内容后添加:', newContent, 'selContent:', this.selContent)
			if (this.selContent) {
				const currentContent = this.getCurrentContent()
				const selectionIndex = currentContent.indexOf(this.selContent)
				if (selectionIndex !== -1) {
					const beforeSelection = currentContent.substring(0, selectionIndex + this.selContent.length)
					const afterSelection = currentContent.substring(selectionIndex + this.selContent.length)
					const newFullContent = beforeSelection + newContent + afterSelection
					this.setCurrentContent(newFullContent)
				} else {
					// 如果找不到选中内容，则在末尾添加
					const newFullContent = currentContent ? currentContent + (currentContent.endsWith('\n') ? '' : '\n') : "" + newContent
					this.setCurrentContent(newFullContent)
				}
			} else {
				// 如果没有选中内容，则在末尾添加
				const currentContent = this.getCurrentContent()
				const newFullContent = currentContent ? currentContent + (currentContent.endsWith('\n') ? '' : '\n') : "" + newContent
				this.setCurrentContent(newFullContent)
			}
		},
		
		// 在光标位置插入内容，如果光标不存在则插入到文章最后面
		insertAtCursor(newContent) {
			console.log('在光标位置插入:', newContent)
			const currentEditor = this.getCurrentEditor()
			if (currentEditor) {
				try {
					const textarea = currentEditor.$el.querySelector('textarea')
					if (textarea) {
						// 编辑器处于焦点状态，获取光标位置
						const cursorPosition = textarea.selectionStart
						const currentContent = this.getCurrentContent()
						
						// 检查光标位置是否有效
						if (cursorPosition >= 0 && cursorPosition <= currentContent.length) {
							const beforeCursor = currentContent.substring(0, cursorPosition)
							const afterCursor = currentContent.substring(cursorPosition)
							const newFullContent = beforeCursor + newContent + afterCursor
							this.setCurrentContent(newFullContent)
							
							// 将光标移动到插入内容的末尾
							this.$nextTick(() => {
								const newCursorPosition = cursorPosition + newContent.length
								textarea.setSelectionRange(newCursorPosition, newCursorPosition)
								textarea.focus()
							})
							return
						}
					}
					
					// 如果光标不存在或无效，则在文章最后面添加
					const currentContent = this.getCurrentContent()
					
					const newFullContent = currentContent ? currentContent + (currentContent.endsWith('\n') ? '' : '\n') : "" + newContent
					this.setCurrentContent(newFullContent)
					
					// 强制刷新编辑器显示并将光标移动到文档末尾
					this.$nextTick(() => {
						// 强制触发编辑器更新
						this.forceEditorUpdate()
						
						if (textarea) {
							textarea.focus()
							const finalContent = this.getCurrentContent()
							textarea.setSelectionRange(finalContent.length, finalContent.length)
						}
					})
					
				} catch (error) {
					console.warn('无法在光标位置插入内容:', error)
					// 降级处理：在文章最后面添加
					const currentContent = this.getCurrentContent()
					const newFullContent = currentContent ? currentContent + (currentContent.endsWith('\n') ? '' : '\n') : "" + newContent
					this.setCurrentContent(newFullContent)
					
					// 强制刷新编辑器显示
					this.$nextTick(() => {
						this.forceEditorUpdate()
					})
				}
			} else {
				// 如果无法获取编辑器，则在文章最后面添加
				const currentContent = this.getCurrentContent()
				const newFullContent = currentContent ? currentContent + (currentContent.endsWith('\n') ? '' : '\n') : "" + newContent
				this.setCurrentContent(newFullContent)
				
				// 强制刷新编辑器显示
				this.$nextTick(() => {
					this.forceEditorUpdate()
				})
			}
		},
		
		// 强制刷新编辑器显示
		forceEditorUpdate() {
			const currentEditor = this.getCurrentEditor()
			if (currentEditor) {
				try {
					// 触发编辑器的强制更新
					if (currentEditor.$forceUpdate) {
						currentEditor.$forceUpdate()
					}

					// 如果编辑器有refresh方法，调用它
					if (currentEditor.refresh) {
						currentEditor.refresh()
					}

					// 触发Vue的强制更新
					this.$forceUpdate()
				} catch (error) {
					console.warn('强制更新编辑器失败:', error)
				}
			}
		},
	onPluginClick(data) {
    this.$refs.menutoolRef.onShow(data.type);
  },
		// AI功能相关方法
		onAiShow(type) {
			// 获取当前选中的文本
			const currentEditor = this.getCurrentEditor()
			if (currentEditor) {
				// 获取v-md-editor的选中文本
				try {
					const selection = currentEditor.getSelection()
					this.selContent = selection || ''
				} catch (error) {
					// 如果getSelection方法不存在，尝试其他方式获取选中文本
					const textarea = currentEditor.$el.querySelector('textarea')
					if (textarea) {
						const start = textarea.selectionStart
						const end = textarea.selectionEnd
						this.selContent = textarea.value.substring(start, end)
					} else {
						this.selContent = ''
					}
				}
			}

			// 对于续写功能，如果没有选中文本，使用当前内容的最后一段作为上下文
			if (!this.selContent && type === 'continueRef') {
				const currentContent = this.getCurrentContent()
				if (currentContent) {
					// 获取最后200个字符作为续写的上下文
					this.selContent = currentContent.slice(-200)
				}
			}

			if (!this.selContent && type !== 'drawRef' && type !== 'creationRef') {
				if (type === 'continueRef') {
					this.$message.warning('请输入一些内容作为续写的基础')
				} else {
					this.$message.warning('请选中文本')
				}
				return
			}

			if (type === 'continueRef') {
				this.$refs.continueRef.onShow()
			} else if (type === 'correctionRef') {
				this.$refs.correctionRef.onShow()
			} else if (type === 'translationRef') {
				this.$refs.translationRef.onShow()
			} else if (type === 'drawRef') {
				this.$refs.drawRef.onShow()
			} else if (type === 'creationRef') {
				this.$refs.creationRef.onShow()
			} else if (type === 'rewriteRef') {
				this.$refs.rewriteRef.onShow()
			}
		},
		// AI续写回调
		onAiContinue(val) {
			const currentEditor = this.getCurrentEditor()
			console.log(currentEditor)
			if (currentEditor && val) {
				// 在选中内容后添加续写内容
				this.insertAfterSelectedContent(val)

				// 滚动到编辑器底部显示新添加的内容
				this.$nextTick(() => {
					try {
						const textarea = currentEditor.$el.querySelector('textarea')
						if (textarea) {
							textarea.scrollTop = textarea.scrollHeight
							// 将光标移动到末尾
							const currentContent = this.getCurrentContent()
							textarea.setSelectionRange(currentContent.length, currentContent.length)
							textarea.focus()
						}
					} catch (error) {
						console.warn('无法滚动到编辑器底部:', error)
					}
				})
			}
		},

		// AI纠错回调
		onAiCorrection(val) {
			this.replaceSelectedContent(val)
		},

		// AI翻译回调
		onAiTranslation(val, type) {
			if (type === 'insertion') {
				const currentContent = this.getCurrentContent()
				this.setCurrentContent(currentContent + val)
			} else {
				this.replaceSelectedContent(val)
			}
		},

		// AI画图回调
		onAiDraw(val) {
			this.insertAtCursor(val)
		},

		// AI创作回调
		onAiCreation(val) {
			this.insertAtCursor(val)
		},

		// AI改写回调
		onAiRewrite(val) {
			console.log('AI改写回调被触发:', val)
			// 如果有选中的文本，替换选中的内容；否则替换全部内容
			if (this.selContent) {
				const currentContent = this.getCurrentContent()
				const newContent = currentContent.replace(this.selContent, val)
				this.setCurrentContent(newContent)
			} else {
				this.setCurrentContent(val)
			}
		},

		// AI素材回调
		onAiMaterial(data, num) {
			let content = ''
			if (num === 0 || num === 1) {
				// 图片素材
				const array = []
				data.forEach(item => {
					array.push(`<img src="${item.url}" style="width: 180px;height:180px ;object-fit: cover;" />`)
				})
				content = array.join('')
			} else if (num === 2) {
				// 文本素材
				const array = []
				data.forEach(item => {
					array.push(item.content)
				})
				content = array.join('')
			}
			const currentContent = this.getCurrentContent()
			this.setCurrentContent(currentContent + content)
		},

		// AI工具回调
		onAiMenutool(data, type) {
			let content = ''
			if (type === 'customlink') {
				content = data
			} else if (type === 'customimage') {
				const array = []
				data.forEach(item => {
					array.push(`<img src="${item.url}" style="width: 180px;height:180px ;object-fit: cover;" />`)
				})
				content = array.join('')
			} else if (type === 'customvideo') {
				const array = []
				data.forEach(item => {
					array.push(`<video style="width: 20vw;height:20vw;object-fit: cover;" controls><source src="${item.url}" /></video>`)
				})
				content = array.join('')
			}
			this.insertAtCursor(content)
		}
	}
}
